var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleDashed = function SvgCircleDashed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 77 77"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M27.398 11.814a28.8 28.8 0 0 0-9.344 6.24m-6.24 9.344a28.8 28.8 0 0 0-2.209 11.008m2.208 11.008a28.8 28.8 0 0 0 6.24 9.343m9.345 6.24a28.8 28.8 0 0 0 11.008 2.209m11.008-2.209a28.8 28.8 0 0 0 9.343-6.24m6.24-9.343a28.8 28.8 0 0 0 2.209-11.008m-2.209-11.008a28.8 28.8 0 0 0-6.24-9.344m-9.343-6.24a28.8 28.8 0 0 0-11.008-2.209"
  })));
};
export default SvgCircleDashed;